@if (members && members.length === 0) {
  <span class="warningbox">You do not have any eligible members for this one time reward.</span>
}
@if (members && members.length > 0) {
  @if (multiple) {
    <div class="buttons">
      <button mat-raised-button class="selectbutton" color="accent" (click)="selectAll()">Select All</button>
      <button mat-raised-button class="selectbutton" color="accent" (click)="deselectAll()">Deselect All</button>
    </div>
  }
  <mat-form-field class="search">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput type="search" placeholder="Search members..." class="search-input" (input)="filterItems($event)">
  </mat-form-field>
  <div>
    @for (member of filteredMembers; track member) {
      <div class="member">
        @if (multiple) {
          <mat-checkbox [checked]="member.selected" (click)="memberCheckboxClicked($event, member)"></mat-checkbox>
        }
        @if (!multiple) {
          <mat-radio-button [checked]="member.selected" (click)="memberCheckboxClicked($event, member)"></mat-radio-button>
        }
        <span class="name">{{member.firstName}} {{member.lastName}}</span>
        <span class="email">{{member.email}}</span>
        <span class="message" >{{member.message}}</span>
      </div>
    }
  </div>
}
